import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IdNameCombination } from '@models/generic/IdNameCombination';

declare var $: any;

// Do not use this component anymore!
@Component({
    selector: 'cerrix-single-combo-box',
    templateUrl: './cerrix-combo-box.component.html',
    styleUrls: ['./cerrix-combo-box.component.scss'],
    imports: [NgClass, FormsModule]
})
export class ComboBoxComponent implements AfterViewInit {
  @Input() comboboxId: string;
  @Input() options: IdNameCombination[];
  @Input() customClass: string;
  @Input() selectedValue: number;

  @Input() prependLabel: string;
  @Input() smallInput: Boolean;

  @Output() onChange = new EventEmitter<any>();
  comboBoxDom: any;

  constructor() { }

  ngAfterViewInit() {
      this.comboBoxDom = $('#' + this.comboboxId);
      this.comboBoxDom.on('change', (e, data) => {
          this.selectedValue = this.comboBoxDom[0].value;
          this.onChange.emit(this.selectedValue);
      });

      this.comboBoxDom.on('clear_value', (event) => {
          this.selectedValue = null;
          this.onChange.emit(this.selectedValue);
      });
  }

  clear() {
      this.comboBoxDom.trigger('clear_value');
  }
}
